/**
 * @generated SignedSource<<1286750bc94024cc60942713147e59ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalScheduleQuery$variables = {
  workspaceId: string;
  workspaceSignalId: string;
};
export type WorkspaceSignalScheduleQuery$data = {
  readonly workspace: {
    readonly signal: {
      readonly expireAtDate: {
        readonly isoString: string;
      } | null;
      readonly id: string;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly updatedAtDate: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
    };
  };
};
export type WorkspaceSignalScheduleQuery = {
  response: WorkspaceSignalScheduleQuery$data;
  variables: WorkspaceSignalScheduleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceSignalId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceSignalId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UnzonedDate",
  "kind": "LinkedField",
  "name": "expireAtDate",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalScheduleQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "SignalWorkspace",
                "kind": "LinkedField",
                "name": "signal",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "updatedAtDate",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FormattedDate"
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceSignalScheduleQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "signal",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0bca36eec06fb8d94dc5f41000390d38",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalScheduleQuery",
    "operationKind": "query",
    "text": "query WorkspaceSignalScheduleQuery(\n  $workspaceSignalId: ID!\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    signal(id: $workspaceSignalId) {\n      id\n      updatedAtDate {\n        ...FormattedDate\n        isoString\n      }\n      receiverStores {\n        id\n      }\n      expireAtDate {\n        isoString\n      }\n    }\n    id\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "435b937904e62342a980d82c16ad4c5c";

export default node;
